import React from 'react'
import './RectangleFrame.scss'

export const RectangleFrame = ({ children, color, className, ...props }) => {
  return <div className={`square-frame-design${color ? '-' + color : ''} text-small ${className}`}>{children}</div>
}
